export type ComparisonBounds = { left: number; top: number; width: number; height: number };
export type ComparisonViewport = { width: number; height: number };
const clamp = (value: number, low: number, high: number) => Math.max(low, Math.min(high, value));

/** Map pointer coordinates against the current transformed artwork, not viewport. */
export function splitFromClientX(clientX: number, artworkLeft: number, artworkWidth: number): number {
  if (![clientX, artworkLeft, artworkWidth].every(Number.isFinite) || artworkWidth <= 0) return 50;
  return clamp((clientX - artworkLeft) / artworkWidth * 100, 0, 100);
}

/** Positions use viewport-local CSS pixels. The line retains the true split;
 * only its 44px control is pinned when panning puts that split offscreen. */
export function comparisonChrome(bounds: ComparisonBounds, viewport: ComparisonViewport, split: number): { lineX: number; top: number; height: number; handleX: number; handleY: number; pinned: boolean } | null {
  if (![bounds.left, bounds.top, bounds.width, bounds.height, viewport.width, viewport.height, split].every(Number.isFinite)
    || bounds.width <= 0 || bounds.height <= 0 || viewport.width <= 0 || viewport.height <= 0) return null;
  const left = Math.max(0, bounds.left), right = Math.min(viewport.width, bounds.left + bounds.width);
  const top = Math.max(0, bounds.top), bottom = Math.min(viewport.height, bounds.top + bounds.height);
  if (right <= left || bottom <= top) return null;
  const lineX = bounds.left + bounds.width * clamp(split, 0, 100) / 100;
  // For a viewport smaller than the hit target, centering is the best possible
  // containment and avoids an inverted clamp range.
  const insetX = Math.min(22, viewport.width / 2), insetY = Math.min(22, viewport.height / 2);
  const handleX = clamp(lineX, insetX, viewport.width - insetX);
  const handleY = clamp((top + bottom) / 2, insetY, viewport.height - insetY);
  return { lineX, top, height: bottom - top, handleX, handleY, pinned: Math.abs(handleX - lineX) > 1e-9 };
}
